module.exports = __webpack_public_path__ + "static/img/image-package.9e64a19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image-package.png
// module id = 477
// module chunks = 1